export default "__VITE_ASSET__BYihvQi5__"